// client/src/pages/admin/project-steps/Step12SectionInfo.tsx
import React from 'react';
import { StepProps } from './types';

const Step12SectionInfo: React.FC<StepProps> = ({ form, setForm, QuickUpdateButton }) => {
    const handleInfoChange = (section: keyof typeof form.sectionInfo, value: string) => {
        if (!setForm) return;
        setForm(prev => ({
            ...prev,
            sectionInfo: {
                ...prev.sectionInfo,
                [section]: value
            }
        }));
    };

    const sections = [
        { id: 'overview', label: 'Overview Section', icon: 'fa-info-circle', placeholder: 'Enter project overview description...' },
        { id: 'amenities', label: 'Amenities Section', icon: 'fa-swimming-pool', placeholder: 'Enter amenities section description...' },
        { id: 'specifications', label: 'Specifications Section', icon: 'fa-tools', placeholder: 'Enter specifications description...' },
        { id: 'floorPlans', label: 'Floor Plans Section', icon: 'fa-layer-group', placeholder: 'Enter floor plan details...' },
        { id: 'location', label: 'Location Section', icon: 'fa-map-marker-alt', placeholder: 'Enter location details...' },
        { id: 'gallery', label: 'Gallery Section', icon: 'fa-images', placeholder: 'Enter gallery description...' },
        { id: 'developer', label: 'Developer Section', icon: 'fa-user-tie', placeholder: 'Enter developer background...' },
        { id: 'nearby', label: 'Nearby Section', icon: 'fa-street-view', placeholder: 'Enter nearby landmarks info...' },
        { id: 'about', label: 'About Section', icon: 'fa-building', placeholder: 'Enter project vision...' },
        { id: 'highlights', label: 'Highlights Section', icon: 'fa-star', placeholder: 'Enter key highlights...' },
        { id: 'faq', label: 'FAQ Section', icon: 'fa-question-circle', placeholder: 'Enter FAQ introduction...' },
        { id: 'reviews', label: 'Reviews Section', icon: 'fa-comments', placeholder: 'Enter reviews section info...' }
    ];

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between mb-4 px-2">
                <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold text-lg shadow-md">
                        10
                    </div>
                    <div>
                        <h5 className="text-xl font-bold text-gray-800">Section Descriptions</h5>
                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Add custom descriptions for each section of the project page.</p>
                    </div>
                </div>
                {QuickUpdateButton && <QuickUpdateButton />}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative z-10">
                {sections.map((sec) => (
                    <div key={sec.id} className="bg-white p-6 rounded-2xl border border-gray-200 space-y-4 shadow-sm hover:border-blue-300 transition-all group">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center border border-blue-900/5">
                                <i className={`fa-solid ${sec.icon} text-sm`}></i>
                            </div>
                            <label className="text-xs font-bold text-gray-800 uppercase tracking-wide">{sec.label}</label>
                        </div>
                        <textarea
                            className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 outline-none focus:border-blue-500 focus:bg-white transition-all font-semibold text-sm min-h-[100px] resize-none text-gray-800"
                            value={form.sectionInfo[sec.id as keyof typeof form.sectionInfo]}
                            onChange={(e) => handleInfoChange(sec.id as keyof typeof form.sectionInfo, e.target.value)}
                            placeholder={sec.placeholder}
                        ></textarea>
                        <div className="flex items-center gap-2">
                            <i className="fa-solid fa-circle-info text-[10px] text-blue-500"></i>
                            <p className="text-[10px] font-semibold text-gray-500">
                                This text will appear in the {sec.id} section. Leave empty to hide.
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Step12SectionInfo;
